import React, { Component } from "react";
import * as helpers from "../helpers/helpers";
import * as drawingHelpers from "../helpers/drawingHelpers";
import Autocomplete from "react-autocomplete";
import "./Search.scss";
import Highlighter from "react-highlight-words";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source.js";
import { Fill, Icon, Stroke, Style, Circle as CircleStyle } from "ol/style.js";
import { transform } from "ol/proj.js";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Select from "react-select";
import { buffer, createEmpty, extend as olExtend } from 'ol/extent';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons/faLocationDot";
import { config } from "yargs";

// URLS

const googleDirectionsURL = (lat, long) => `https://www.google.com/maps?saddr=Current+Location&daddr=${lat},${long}`;
//const searchURL = (apiUrl, searchText, type, muni, limit) => `${apiUrl}search/search?q=${searchText}&type=${type}&muni=${muni}&limit=${limit}&appname=` + window.config.appName;
const searchURL = (apiUrl, searchText, type, muni, limit) => `${apiUrl}search/searchids?q=${searchText}&type=${type}&muni=${muni}&limit=${limit}&appname=` + window.config.appName;
const searchInfoURL = (apiUrl, locationID, src) => `${apiUrl}search/searchByIds/${src}/${locationID}/?appname=` + window.config.appName;
const searchTypesURL = (apiUrl) => `${apiUrl}search/getSearchTypes?appname=` + window.config.appName;

// DEFAULT SEARCH LIMIT
const defaultSearchLimit = 10;

// VECTOR LAYERS
let searchGeoLayer = null;
let searchIconLayer = null;

// LOCATION ID (FROM SEARCH)
const locationId = helpers.getURLParameter("LOCATIONID", false);

// IMPORT ALL IMAGES
const images = importAllImages(require.context("./images", false, /\.(png|jpe?g|svg)$/));
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
  return images;
}

class Search extends Component {
  constructor(props) {
    super(props);

    // STYLES
    this.styles = {
      poly: new Style({
        stroke: new Stroke({
          width: 4,
          color: [255, 0, 0, 0.8],
        }),
        fill: new Fill({
          color: [0, 0, 255, 0.1],
        })
      }),
      point: new Style({
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color: [255, 0, 0, 0.8]
          }),
          stroke: new Stroke({
            color: [0, 0, 0, 1],
            width: 2
          })
        })
      }),
      geocode: new Style({
        image: new CircleStyle({
          opacity: 0.5,
          radius: 7,
          fill: new Fill({ color: [236, 156, 155, 0.7] }),
        }),
      }),
    };

    // BIND THIS TO THE CLICK FUNCTION
    this.removeMarkersClick = this.removeMarkersClick.bind(this);
    this.cleanup = this.cleanup.bind(this);

    // LISTEN FOR MAP TO MOUNT
    window.emitter.addListener("cleanUpSearch", () => this.cleanup());

    window.emitter.addListener("mapParametersComplete", () => this.onMapLoad());

    // LISTEN FOR SEARCH FROM HISTORY
    window.emitter.addListener("searchHistorySelect", (item) => this.onHistoryItemSelect(item));

    // LISTEN FOR INITIAL SEARCH
    window.emitter.addListener("tocLoaded", () => this.onInitialSearch());

    // LISTEN FOR EXTERNAL COMPONENT SEARCH
    window.emitter.addListener("searchItem", (searchType, searchText, hidden = false) => this.onSearch(searchType, searchText, hidden));

    // Stavový atribút na window objekt
    window.isPriorityPopupOpen = false;

    this.state = {
      value: "",
      searchResults: [],
      hover: false,
      iconInitialClass: "sc-search-icon-initial",
      iconActiveClass: "sc-search-icon-active-hidden",
      showMore: false,
      searchTypes: [],
      selectedType: "",
      municipality: undefined,
      placeHolderText: "Hľadaj...",
      hideTypeDropDown: false,
    };
  }

  requestTimer = null;

  onMapLoad = () => {
    helpers.waitForLoad("map", Date.now(), 30, () => {
      // HANDLE URL PARAMETER
      if (locationId !== null) {
        // CALL API TO GET LOCATION DETAILS
        helpers.getJSON(searchInfoURL(this.apiUrl, locationId), (result) => this.jsonCallback(result));
      }
    });
  };

  componentDidMount() {
    //ideme robit bordel

    // get token from arcgis server with credentials and post react app url as referer
    // fetch('https://geoportal.esprit.sk/arcgis/sharing/rest/generateToken', {

    /*    
        let data = {
          'username': "esprit",
          'password': "Stolicka4dva",
          'referer': "https://andrej:3000/hm"
        };
        var formBody = [];
        for (var property in data) {
          var encodedKey = encodeURIComponent(property);
          var encodedValue = encodeURIComponent(data[property]);
          formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        
    
        let url = 'https://portal.esprit-bs.sk/portal/sharing/rest/generateToken/?f=json'    
        fetch(url, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, cors, *same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',        
          },      
          referrer: "no-referrer", // no-referrer, *client
          body: formBody, // body data type must match "Content-Type" header
        })
          .then((res) => {
            console.log(res);
          })
          .then((json) => {
            console.log(json);
          });
    
    
    
        fetch('https://portal.esprit-bs.sk/portal/sharing/rest/generateToken/?f=json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
          .then(response => response.json())
          .then(data => {
            // Handle the response data
            console.log(data);
          })
          .catch(error => {
            // Handle any errors
            console.error('Error:', error);
          });
    */
    helpers.waitForLoad(["map", "settings"], Date.now(), 30, () => {
      if (window.config.municipality !== undefined) this.setState({ municipality: window.config.municipality });
      this.apiUrl = window.config.apiUrlEsprit;
      this.storageKey = window.config.storageKeys.SearchHistory;
      if (window.config.search) {
        if (window.config.search.placeHolder !== undefined) this.setState({ placeHolderText: window.config.search.placeHolder });
        if (window.config.search.hideTypes !== undefined) this.setState({ hideTypeDropDown: window.config.search.hideTypes });
      }
      if (window.config.searchToolbar) {
        let result = window.config.searchToolbar.map(item => item.alias);
        let items = [];
        if (window.config.displayAllSearch) {
          items.push({ label: "Všetky", value: "ALL" });
        }
        result.forEach((type) => {
          const obj = { label: type, value: type };
          items.push(obj);
        });
        /*items.push({ label: "Open Street Map", value: "Open Street Map" });
        items.push({ label: "Map Layer", value: "Map Layer" });
        items.push({ label: "Tool", value: "Tool" });
        items.push({ label: "Theme", value: "Theme" });*/
        this.setState({ searchTypes: items, selectedType: items[0] });
      } else {
        helpers.getJSON(searchTypesURL(this.apiUrl), (result) => {
          let items = [];
          console.log(window.config.displayAllSearch);
          if (window.config.displayAllSearch) {
            items.push({ label: "Všetky", value: "ALL" });
          }
          result.forEach((type) => {
            const obj = { label: type, value: type };
            items.push(obj);
          });
          /*items.push({ label: "Open Street Map", value: "Open Street Map" });
          items.push({ label: "Map Layer", value: "Map Layer" });
          items.push({ label: "Tool", value: "Tool" });
          items.push({ label: "Theme", value: "Theme" });*/
          this.setState({ searchTypes: items, selectedType: items[0] });
        });

      }

      // PATCH TO CLOSE MENU WHEN MAP IS CLICKED
      this.clickEvent = document.body.addEventListener(
        "click",
        (evt) => {
          if (document.activeElement.id !== "sc-search-textbox") return;
          if (typeof evt.target.className === "string") {
            evt.target.className.split(" ").forEach((className) => {
              if (className === "ol-overlaycontainer-stopevent") {
                document.getElementById("map").focus();
              }
            });
          }
        },
        true
      );

      // listener na otvorenie a zatvorenie popupu
      window.emitter.addListener("openPriorityPopup", () => {
        console.log("openPriorityPopup");
        window.isPriorityPopupOpen = true;
      });

      window.emitter.addListener("closePriorityPopup", () => {
        window.isPriorityPopupOpen = false;
      });
    });
  }

  onHistoryItemSelect = (item) => {
    let searchResults = [item];
    if (this.state.searchResults.length > 0) searchResults.push(this.state.searchResults);
    let value = item.name.length > 25 ? item.name.substring(0, 25) : item.name;
    this.setState({ value: value, searchResults: searchResults }, () => {
      this.onItemSelect(value, item);
    });
  };

  onInitialSearch = (search_type = undefined, search = undefined) => {
    // GET SEARCH URL PARAMETERS
    if (!search) search = helpers.getURLParameter("q", true, true);
    if (!search_type) search_type = helpers.getURLParameter("qt", true, true);
    if (!search && search === null) return;
    if (!search_type && search_type === null) {
      search_type = "All";
    }
    this.onSearch(search_type, search);
  };

  onSearch = (search_type = undefined, search = undefined, hidden = false) => {
    if (!search && search === null) return;
    if (!search_type && search_type === null) {
      search_type = "All";
    }
    if (!hidden)
      this.setState({
        value: search,
        selectedType: { label: search_type, value: search_type },
      });
    helpers.getJSON(encodeURI(searchURL(this.apiUrl, search, search_type, this.state.municipality, 1)), (responseJson) => {
      if (responseJson[0] !== undefined && responseJson[0].location_id !== null && responseJson[0].location_id !== undefined) {
        helpers.getJSON(searchInfoURL(this.apiUrl, responseJson[0].location_id), (result) => this.jsonCallback(result, hidden));
      }
    });
  };

  onTypeDropDownChange = (selectedType) => {
    this.setState({ selectedType: selectedType }, async () => {
      let limit = defaultSearchLimit;
      if (this.state.showMore) limit = 50;
      await helpers.getJSONWait(searchURL(this.apiUrl, this.state.value, this.state.selectedType.value, this.state.municipality, limit), (responseJson) => {
        if (responseJson !== undefined) this.setState({ searchResults: responseJson });
        else this.setState({ searchResults: [] });
      });
    });

    helpers.addAppStat("Search Type DropDown", selectedType.value);
  };

  removeMarkersClick() {
    this.cleanup();
  }

  saveAsPreviousResult = (evt) => {
    evt.stopPropagation();

    if (this.state.addIcon === "check") return;
    this.setState({ addIcon: "check" });

    const filterResults = window.filterResults;
    const item = {
      name: this.state.title,
      layerName: this.state.layerName,
      geoJson: [],
      serverUrl: window.config.geoserverUrl,
      cqlFilter: null,
      maxRecords: null,
      sortFields: null,
      scrollTop: 0,
      id: this.state.title,
      alias: [this.state.layerName, this.state.id].join("_"),
    };
    window.filterResults = [...filterResults, item];
    // window.dispatchEvent(new Event("filterResultsChanged"));
  };


  myMapsClick = (evt) => {
    helpers.waitForLoad("map", Date.now(), 30, () => {
      const result = this.state.searchResults[0];
      //if (searchIconLayer.getSource().getFeatures()[0] === undefined) return;
      // ADD MYMAPS
      if (searchGeoLayer.getSource().getFeatures().length === 0) window.emitter.emit("addMyMapsFeature", searchIconLayer.getSource().getFeatures()[0], result.name);
      else window.emitter.emit("addMyMapsFeature", searchGeoLayer.getSource().getFeatures()[0], result.name);

      // CLEAN UP
      this.cleanup();
    });
  };

  directionsClick(evt) {
    // GET CURRENT FEATURE
    var coords = searchIconLayer.getSource().getFeatures()[0].getGeometry().getCoordinates();

    // CONVER TO LAT LONG
    var latLongCoords = transform(coords, "EPSG:3857", "EPSG:4326");

    // OPEN GOOGLE DIRECTIONS
    var url = googleDirectionsURL(latLongCoords[1], latLongCoords[0]);
    window.open(url, "_blank");
  }

  // INIT SEARCH LAYERS
  initsearchLayers() {
    if (window.map != null && searchGeoLayer == null) {
      // HOLDS LINES AND POLYS
      searchGeoLayer = new VectorLayer({
        source: new VectorSource({
          features: [],
        }),
        zIndex: 1000,
      });
      searchGeoLayer.set("name", "sc-search-geo");
      window.map.addLayer(searchGeoLayer);

      // HOLDS CENTROID (CLICKABLE)
      searchIconLayer = new VectorLayer({
        source: new VectorSource({
          features: [],
        }),
        zIndex: 1000,
      });
      searchIconLayer.setStyle(this.styles["point"]);
      searchIconLayer.set("name", "sc-search-icon");
      searchIconLayer.set("disableParcelClick", true);
      window.map.addLayer(searchIconLayer);

      window.map.on("singleclick", (evt) => {
        console.log('clicol som');
        var feature = window.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
          if (layer === null) return;
          if (layer.get("name") !== undefined && layer.get("name") === "sc-search-geo") return feature;
        });

        if (feature !== undefined) {
          console.log("feature !== undefined", feature !== undefined)
          window.emitter.emit("openPriorityPopup");
          window.popup.show(
            evt.coordinate,
            <PopupContent
              key={helpers.getUID()}
              feature={feature}
              removeMarkersClick={this.removeMarkersClick}
              myMapsClick={this.myMapsClick}
              shareLocationId={this.state.searchResults[0].location_id}
              directionsClick={(evt) => this.directionsClick(evt)}
            />,
            "Možnosti"
          );
        } else {
          console.log("else feature === undefined")
          window.emitter.emit("closePopup");
          window.emitter.emit("closePriorityPopup");
          window.emitter.emit("removeRowHighlight");
        }
      });
    }
  }

  jsonCallback(result, hidden = false) {
    console.log("jsonCallback", result);
    result.geojson = result;
    console.log(result.features[0].geometry.type);
    let geometryType = result.features[0].geometry.type;

    window.result = result;
    /*const excludeKey = ["shape"];
    let {[excludeKey]:excluded, ...rest} = result[0];
    result.geojson.properties = {...rest};
    delete (result.geojson.properties["shape"]);
    let properties = result.geojson.properties;
    debugger*/
    //get rid with circular structure not with JSON.parse(JSON.stringify())
    //result.goojsonstring = JSON.stringify(result.geojson);
    if (!hidden) {
      const savedResult = Object.assign({}, result);
      delete savedResult["geojson"];
      helpers.appendToStorage(this.storageKey, savedResult, 25);
    }

    // EMTI SEARCH COMPLETE
    window.emitter.emit("searchComplete", result);

    this.initsearchLayers();
    // CLEAR PREVIOUS SOURCE
    searchGeoLayer.getSource().clear();
    searchIconLayer.getSource().clear();
    // SET STATE CURRENT ITEM - this item is not needed for either Option for searchBarValueChangeOnClick
    // if (!hidden) this.setState({ searchResults: [result] });

    //CHECK FOR ASSOCIATED LAYERS
    if (result.assoc_layers !== undefined && result.assoc_layers !== null && window.config.searchResultLayerActivate === true) {
      let assocLayers = result.assoc_layers.split(",");
      if (assocLayers.length > 0) {
        assocLayers.forEach((assocLayer) => {
          if (assocLayer.split("@")[0] !== undefined && assocLayer.split("@")[0] !== null && assocLayer.split("@")[1] !== undefined && assocLayer.split("@")[1] !== null) {
            let item = { fullName: assocLayer.split("@")[0], layerGroup: assocLayer.split("@")[1], itemAction: "Activate" };
            let emmiting = false;
            window.emitter.emit("activeTocLayerGroup", item.layerGroup, () => {
              if (!emmiting) window.emitter.emit("activeTocLayer", item);
              emmiting = true;
            });
          }
        });
      }
    }
    // GET GEOJSON VALUES
    console.log(result.geojson);
    //debugtemp
    let debugGeojson = JSON.parse('{"type":"FeatureCollection","features":[{"type":"Feature","geometry":{"type":"MultiLineString","crs":{"type":"name","properties":{"name":"EPSG:5514"}},"coordinates":[[[-271501.198990615,-1255272.303150162],[-271506.41536261,-1255314.816581924],[-271532.671101653,-1255512.430141012],[-271540.147901513,-1255565.289377231],[-271548.494096706,-1255626.494808643],[-271568.316310288,-1255774.292015176],[-271583.617668141,-1255883.140310812],[-271585.356458806,-1255903.13640346],[-271587.443007604,-1255956.169518746],[-271590.225072668,-1256023.112959353],[-271593.354895865,-1256041.718019469],[-271596.658598129,-1256051.455247194],[-271601.701091058,-1256061.018595852],[-271621.349425573,-1256089.708641826],[-271686.380196448,-1256170.736286819],[-271731.067116541,-1256226.986164836],[-271769.059692574,-1256273.151056994],[-271803.661626809,-1256316.446944555],[-271874.952044078,-1256405.994663807],[-271907.641308582,-1256445.291332839],[-271918.421810706,-1256456.245714029],[-271929.028433763,-1256463.505165055],[-271939.729317665,-1256468.067764282],[-271948.155131079,-1256470.503797482],[-271957.892358804,-1256471.329723048],[-272013.794478687,-1256467.069685919],[-272072.652542701,-1256463.070467389]]]}},{"type":"Feature","geometry":{"type":"MultiLineString","crs":{"type":"name","properties":{"name":"EPSG:5514"}},"coordinates":[[[-278130.545469761,-1254630.172386169],[-278166.239492893,-1254804.136354446],[-278169.68792057,-1254831.734493256],[-278166.309178574,-1254850.6599869],[-278157.962983382,-1254874.713257768],[-278118.666314351,-1254955.393144628],[-278109.830673695,-1254974.998167038],[-278083.194984783,-1255028.306433185],[-278018.975649552,-1255160.686362488],[-277978.751625499,-1255244.959750057],[-277887.118169785,-1255435.01414299],[-277870.830684885,-1255467.409035812],[-277863.759602847,-1255484.796942463],[-277858.615192413,-1255503.03638649],[-277857.61587583,-1255512.153915594],[-277857.152198319,-1255524.32545025],[-277858.543230851,-1255537.308420549],[-277875.895735264,-1255671.806407928],[-277894.941915441,-1255821.310895849],[-277909.779595783,-1255937.80987041],[-277917.615992394,-1255999.661802796],[-277921.557251234,-1256028.757566592],[-277924.223396921,-1256050.434490217]]]}},{"type":"Feature","geometry":{"type":"MultiLineString","crs":{"type":"name","properties":{"name":"EPSG:5514"}},"coordinates":[[[-579018.34370459,-1245848.943694534],[-579141.070853995,-1246014.220577994],[-579174.595372372,-1246059.95749004],[-579179.39867483,-1246066.077827042],[-579190.24484167,-1246073.902561691],[-579253.307554582,-1246147.114187861]]]}}]}');
    // Note: Search component
    let fullFeature = helpers.getFeaturesFromGeoJSON(result);
    //console.log('tu');
    //let fullFeature = helpers.getFeaturesFromGeoJSON(debugGeojson);
    //console.log(fullFeature);
    /*fullFeature.values_ = {...properties, ...fullFeature.values_};
    window.emitter.emit(
      'openAttTabGEOJSON',
      'search',
      [fullFeature],
      5,
      'kn',
      'openAttTabGEOJSON',
      'openAttTabGEOJSON',
      false
    )*/
    //let pointFeature = helpers.getFeatureFromGeoJSON(result.geojson_point);
    //pointFeature.setProperties({ isPlaceOrGeocode: false });

    if (!hidden) {
      // SET SOURCE
      /*fullFeature.setProperties({
        label: result.alias ? result.alias : result.name,
        name: result.name,
        is_open_data: result.is_open_data !== undefined && result.is_open_data !== null ? result.is_open_data : true,
      });*/
      fullFeature.forEach(function (feature) {
        feature.setProperties({
          label: result.alias ? result.alias : result.name,
          name: result.name,
          is_open_data: result.is_open_data !== undefined && result.is_open_data !== null ? result.is_open_data : true,
        })
      });
      /*pointFeature.setProperties({
        label: result.alias ? result.alias : result.name,
        name: result.name,
        is_open_data: result.is_open_data !== undefined && result.is_open_data !== null ? result.is_open_data : true,
      });*/
      /*window.map.getView().fit(buffer(fullFeature.getGeometry().getExtent(), 500), window.map.getSize(), {
        duration: 1000,
      });*/

      var extent = createEmpty();

      // Loop through all features and extend the combined extent
      fullFeature.forEach(function (feature) {
        olExtend(extent, feature.getGeometry().getExtent());
        searchGeoLayer.getSource().addFeature(feature);
      });
      window.map.getView().fit(buffer(extent, 500), window.map.getSize(), {
        duration: 1000,
      });


      //searchIconLayer.getSource().addFeature(pointFeature);

      searchGeoLayer.setZIndex(300);
      searchIconLayer.setZIndex(300);
    }

    let zoomFactor = window.config.featureHighlitStyles && window.config.featureHighlitStyles["zoomFactor"] >= 0 ? window.config.featureHighlitStyles["zoomFactor"] : 1;
    console.log(zoomFactor);
    if (zoomFactor === 1) { zoomFactor = 2; }
    if (geometryType.indexOf("Point") !== -1) {
      searchGeoLayer.setStyle(this.styles["point"]);
      /*window.map.getView().fit(fullFeature.getGeometry().getExtent(), window.map.getSize(), {
        duration: 1000,
      });
      window.map.getView().setZoom(13 - zoomFactor);*/
    } else if (geometryType.indexOf("Line") !== -1) {
      searchGeoLayer.setStyle(this.styles["poly"]);
      /*window.map.getView().fit(fullFeature.getGeometry().getExtent(), window.map.getSize(), {
        duration: 1000,
      });
      window.map.getView().setZoom(window.map.getView().getZoom() - zoomFactor);*/
    } else {
      searchGeoLayer.setStyle(this.styles["poly"]);
      /*window.map.getView().fit(fullFeature.getGeometry().getExtent(), window.map.getSize(), {
        duration: 1000,
      });
      window.map.getView().setZoom(window.map.getView().getZoom() - zoomFactor);*/
    }

    //fullFeature.setStyle(myMapsHelpers.getDefaultDrawStyle([255, 0, 0, 0.8], false, 2, fullFeature.getGeometry().getType()));
    //fullFeature.setStyle(defaultStyle);
    /*if (result.goojsonstring.indexOf("Point") !== -1) {
      const pointStyle = new Style({
        image: new CircleStyle({
          radius:
            window.config.featureHighlitStyles && window.config.featureHighlitStyles["circleRadius"] !== null a
          window.config.featureHighlitStyles["circleRadius"]
              : 5,
          stroke: new Stroke({
            color:
              window.config.featureHighlitStyles && window.config.featureHighlitStyles["circleStroke"] !== null && window.config.featureHighlitStyles["circleStroke"] !== undefined
                ? window.config.featureHighlitStyles["circleStroke"]
                : [0, 0, 0, 1],
            width:
              window.config.featureHighlitStyles && window.config.featureHighlitStyles["circleStrokeWidth"] !== null && window.config.featureHighlitStyles["circleStrokeWidth"] !== undefined
                ? window.config.featureHighlitStyles["circleStrokeWidth"]
                : 2,
          }),
          fill: new Fill({
            color:
              window.config.featureHighlitStyles && window.config.featureHighlitStyles["circleFill"] !== null && window.config.featureHighlitStyles["circleFill"] !== undefined
                ? window.config.featureHighlitStyles["circleFill"]
                : [250, 40, 255, 1],
          }),
        }),
      });

      fullFeature.setStyle(pointStyle);
    } else {
      let defaultStyle = drawingHelpers.getDefaultDrawStyle(
        window.config.featureHighlitStyles && window.config.featureHighlitStyles["stroke"] !== null && window.config.featureHighlitStyles["stroke"] !== undefined
          ? window.config.featureHighlitStyles["stroke"]
          : [255, 0, 0, 0.8],
        false,
        window.config.featureHighlitStyles["strokeWidth"] !== null && window.config.featureHighlitStyles["strokeWidth"] !== undefined ? window.config.featureHighlitStyles["strokeWidth"] : 2,
        fullFeature.getGeometry().getType()
      );
      defaultStyle.setFill(
        new Fill({
          color:
            window.config.featureHighlitStyles && window.config.featureHighlitStyles["fill"] !== null && window.config.featureHighlitStyles["fill"] !== undefined
              ? window.config.featureHighlitStyles["fill"]
              : [255, 0, 0, 0],
        })
      );
      fullFeature.setStyle(defaultStyle);
    }*/
  }

  // WHEN USER SELECTS ITEM
  onItemSelect(value, item) {
    if (item.type === "Map Layer") {
      let emmiting = false;
      window.emitter.emit("activeTocLayerGroup", item.layerGroup, () => {
        if (!emmiting) window.emitter.emit("activeTocLayer", item);
        emmiting = true;
      });
      return;
    }

    if (item.type === "Tool") {
      window.emitter.emit("activateTab", "tools");
      window.emitter.emit("activateSidebarItem", item.name, "tools");
      return;
    }

    if (item.type === "Theme") {
      window.emitter.emit("activateTab", "themes");
      window.emitter.emit("activateSidebarItem", item.name, "themes");
      return;
    }

    // CLEAR PREVIOUS SOURCE
    searchGeoLayer.getSource().clear();
    searchIconLayer.getSource().clear();

    // SET STATE CURRENT ITEM
    const searchBarValueChangeOnClick = window.config.searchBarValueChangeOnClick;

    if (searchBarValueChangeOnClick !== false) {
      this.setState({ value, searchResults: [item] });
    }

    if (item.place_id !== undefined || item.location_id == null) {
      this.initsearchLayers();

      // SET STATE CURRENT ITEM
      this.setState({ searchResults: [item] });

      // HANDLE OSM RESULT
      let coords = [];
      let feature = null;
      if (item.place_id !== undefined) {
        coords = helpers.toWebMercatorFromLatLong([item.x, Math.abs(item.y)]);
        feature = new Feature(new Point(coords));
      } else feature = new Feature(new Point([item.x, item.y]));

      feature.setProperties({ isPlaceOrGeocode: true });

      // SET SOURCE
      searchIconLayer.getSource().addFeature(feature);

      searchGeoLayer.setZIndex(100);
      searchIconLayer.setZIndex(100);

      // SET STYLE AND ZOOM
      searchGeoLayer.setStyle(this.styles["point"]);
      window.map.getView().fit(feature.getGeometry().getExtent(), window.map.getSize(), {
        duration: 1000,
      });
      window.map.getView().setZoom(18);
    } else {
      // CALL API TO GET LOCATION DETAILS
      helpers.getJSON(searchInfoURL(this.apiUrl, item.location_id, item.src), (result) => this.jsonCallback(result));
    }
  }

  cleanup() {
    // REMOVE FEATURES
    searchGeoLayer.getSource().clear();
    searchIconLayer.getSource().clear();

    // HIDE POPUP
    window.popup.hide();
    this.setState({ value: "", iconActiveClass: "sc-search-icon-active-hidden", iconInitialClass: "sc-search-icon-initial" });

    // Zatvorenie popupu
    window.emitter.emit("closePriorityPopup");
  }

  onMoreOptionsClick = (evt) => {
    this.setState(
      (prevState) => ({
        showMore: !prevState.showMore,
      }),
      async () => {
        let limit = defaultSearchLimit;
        if (this.state.showMore) limit = 50;
        await helpers.getJSONWait(searchURL(this.apiUrl, this.state.value, this.state.selectedType.value, this.state.municipality, limit), (responseJson) => {
          if (responseJson !== undefined) this.searchResultsHandler(responseJson, limit);
          else this.searchResultsHandler(responseJson, limit);
        });
      }
    );

    helpers.addAppStat("Search More Button", "Click");
  };

  searchLayers = () => { };

  searchResultsHandler = (results, limit) => {
    let newResults = Object.assign([], results);
    if (this.state.value.length < 2) {
      this.setState({ searchResults: [] });
      return;
    }
    const selectedType = this.state.selectedType.value;

    // SET IMAGE NAME
    newResults.forEach((layer) => {
      layer.imageName = "map-marker-light-blue.png";
    });

    // SEARCH LAYERS
    if (selectedType === "All" || selectedType === "Map Layer") {
      let layers = [];
      const searchResultTOC_Actions = window.config.searchResultTOC_Actions !== undefined ? window.config.searchResultTOC_Actions.toLowerCase() : "Default";
      // eslint-disable-next-line
      window.emitter.emit("getLayerList", (groups) => {
        Object.entries(groups).forEach((row) => {
          const layerItems = row[1];
          layerItems.forEach((layer) => {
            if (layer.tocDisplayName !== undefined) {
              if (layer.tocDisplayName.toUpperCase().indexOf(this.state.value.toUpperCase()) >= 0) {
                layers.push({
                  fullName: layer.name,
                  name: layer.tocDisplayName,
                  type: "Map Layer",
                  layerGroupName: layer.groupName,
                  layerGroup: layer.group,
                  imageName: searchResultTOC_Actions === "advanced" && layer.visible ? "layers-visible.png" : "layers.png",
                  index: layer.index,
                });
              }
            }
          });
        });
      });
      newResults = layers.concat(newResults);
    }

    // TOOLS
    if ((selectedType === "All" || selectedType === "Tool") && window.config.mainSidebarItems !== undefined && window.config.mainSidebarItems["hideTools"] !== true) {
      let tools = [];
      // eslint-disable-next-line
      window.config.sidebarToolComponents.forEach((tool) => {
        if (tool.name.toUpperCase().indexOf(this.state.value.toUpperCase()) >= 0 && (tool.enabled === undefined || tool.enabled)) {
          tools.push({
            name: helpers.replaceAllInString(tool.name, "_", " "),
            type: "Tool",
            imageName: "tools.png",
          });
        }
      });
      newResults = tools.concat(newResults);
    }

    // THEMES
    if ((selectedType === "All" || selectedType === "Theme") && window.config.mainSidebarItems !== undefined && window.config.mainSidebarItems["hideThemes"] !== true) {
      let themes = [];
      window.config.sidebarThemeComponents.forEach((theme) => {
        if (theme.name.toUpperCase().indexOf(this.state.value.toUpperCase()) >= 0 && (theme.enabled === undefined || theme.enabled)) {
          themes.push({
            name: helpers.replaceAllInString(theme.name, "_", " "),
            type: "Theme",
            imageName: "themes.png",
          });
        }
      });
      newResults = themes.concat(newResults);
    }

    this.setState({ searchResults: newResults });
  };

  render() {
    // INIT LAYER
    this.initsearchLayers();

    let dropDownWidth = 50;
    if (this.state.selectedType !== "") dropDownWidth = dropDownWidth + this.state.selectedType.label.length * 9;
    if (this.autoCompleteRef !== undefined) {
      const el = document.getElementById("sc-search-textbox");
      if (!this.state.hideTypeDropDown) el.setAttribute("style", "padding-left: " + (dropDownWidth + 5) + "px");
      else el.setAttribute("style", "padding-left: 5px");
    }

    const groupsDropDownStyles = {
      control: (provided) => ({
        ...provided,
        minHeight: "38px",
        // width: "150px"
        width: dropDownWidth + "px",
        border: "none",
        boxShadow: "none",
        background: "transparent",
        backgroundColor: "unset",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "38px",
      }),
      clearIndicator: (provided) => ({
        ...provided,
        padding: "5px",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: "5px",
      }),
      menu: (provided) => ({
        ...provided,
        width: "200px",
      }),
      container: (provided) => ({
        ...provided,
        width: "100%",
      }),
    };

    return (
      <div>
        <div className={this.state.hideTypeDropDown ? "sc-hidden" : "sc-search-types-container"} tabIndex="-1">
          <Select tabIndex="-1" styles={groupsDropDownStyles} isSearchable={false} onChange={this.onTypeDropDownChange} options={this.state.searchTypes} value={this.state.selectedType} />
        </div>

        <Autocomplete
          ref={(el) => (this.autoCompleteRef = el)}
          inputProps={{
            id: "sc-search-textbox",
            tabIndex: "1",
            placeholder: this.state.placeHolderText,
            name: "sc-search-textbox",
            onFocus: (result) => {
              helpers.disableKeyboardEvents(true);
            },
            onBlur: (result) => {
              helpers.disableKeyboardEvents(false);
            },
          }}
          className="sc-search-textbox"
          wrapperStyle={{
            position: "relative",
            display: "inline-block",
            width: "100%",
            zIndex: "100000",
          }}
          value={this.state.value}
          items={this.state.searchResults}
          getItemValue={(item) => item.name}
          onSelect={(value, item) => {
            this.onItemSelect(value, item);
          }}
          onChange={async (event, value) => {
            // CHECK FOR ILLEGAL CHARS          
            if (value.indexOf("\\") !== -1) {
              return;
            }
            this.setState({ value });
            if (value !== "") {
              this.setState({
                iconInitialClass: "sc-search-icon-initial-hidden",
              });
              this.setState({ iconActiveClass: "sc-search-icon-active" });

              let limit = defaultSearchLimit;
              if (this.state.showMore) limit = 50;
              if (value.length < 2) return;
              await helpers.getJSONWait(searchURL(this.apiUrl, value, this.state.selectedType.value, this.state.municipality, limit), (responseJson) => {
                if (responseJson !== undefined) this.searchResultsHandler(responseJson, defaultSearchLimit);
              });
            } else {
              this.setState({ iconInitialClass: "sc-search-icon-initial" });
              this.setState({
                iconActiveClass: "sc-search-icon-active-hidden",
              });

              this.setState({ searchResults: [] });
            }
          }}
          renderMenu={(children) => (
            <div>
              <div className={this.state.showMore && this.state.searchResults.length > 9 ? "sc-search-menu sc-search-menu-scrollable" : "sc-search-menu"}>{children}</div>
              <MoreOptions numResults={this.state.searchResults.length} onMoreOptionsClick={this.onMoreOptionsClick} showMore={this.state.showMore} />
            </div>
          )}
          renderItem={(item, isHighlighted) => {
            let type = "Unknown";
            if (item.type === "Map Layer") type = item.layerGroupName;
            else if (item.type === "Tool" || item.type === "Theme") type = "";
            else type = "";
            return (
              <div className={isHighlighted ? "sc-search-item-highlighted" : "sc-search-item"} key={helpers.getUID()}>
                <div className="sc-search-item-left">
                  {/* <img src={item.imageName === undefined ? images["map-marker-light-blue.png"] : images[item.imageName]} alt="blue pin" /> */}
                  <FontAwesomeIcon className="faLocationDot-icon" icon={faLocationDot} />
                </div>
                <div className="sc-search-item-content">
                  <Highlighter highlightClassName="sc-search-highlight-words" searchWords={[this.state.value]} textToHighlight={item.name} autoEscape={true}/>
                  <div className="sc-search-item-sub-content">{type === "" ? item.type : " - " + type + " (" + item.type + ")"}</div>
                </div>
              </div>
            );
          }}
        />
        <img className={this.state.iconInitialClass} src={images["magnify.png"]} alt="search" />
        <img className={this.state.iconActiveClass} src={images["clear.png"]} alt="clear" onClick={this.cleanup} />
      </div>
    );
  }
}

export default Search;

class PopupContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
      shareURL: this.getShareURL(),
    };

    this.isPlaceOrGeocode = this.props.feature.get("isPlaceOrGeocode");
  }

  getShareURL = (value) => {
    //GET URL
    var url = window.location.href;

    //ADD LOCATIONID
    if (url.indexOf("?") > 0) {
      let newUrl = helpers.removeURLParameter(url, "LOCATIONID");
      if (newUrl.indexOf("?") > 0) {
        url = newUrl + "&LOCATIONID=" + this.props.shareLocationId;
      } else {
        url = newUrl + "?LOCATIONID=" + this.props.shareLocationId;
      }
    } else {
      url = url + "?LOCATIONID=" + this.props.shareLocationId;
    }

    return url;
  };

  onShareClick = (event) => {
    this.setState({ copied: true });
    // helpers.showMessage("Share", "Link has been copied to your clipboard.", "green", 2000);
  };

  render() {
    return (
      <div>
        <button className="sc-button sc-search-popup-content-button" onClick={this.props.removeMarkersClick}>
          Vymazať značku
        </button>
        <button className="sc-button sc-search-popup-content-button" onClick={this.props.myMapsClick}>
          Pridať do vlastných poznámok
        </button>
        {/* <button className="sc-button sc-search-popup-content-button" onClick={this.props.saveAsPreviousResult}>
          Pridať do uložených výsledkov
        </button> */}
      </div>
    );
  }
}
/*
        <!--<CopyToClipboard text={this.state.shareURL}>
          <button className={this.isPlaceOrGeocode ? "sc-hidden" : "sc-button sc-search-popup-content-button"} onClick={this.onShareClick}>
            Share this Location
          </button>
        </CopyToClipboard>
        <button className="sc-button sc-search-popup-content-button" onClick={this.props.directionsClick}>
          Directions to Here
        </button>-->
*/
const MoreOptions = (props) => {
  return (
    <div className={props.numResults > 9 ? "sc-search-menu-options" : "sc-hidden"}>
      <button className="sc-button sc-search-more-options-button" onClick={props.onMoreOptionsClick}>
        {props.showMore ? "Zobraziť menej" : "Zobraziť viac"}
      </button>
    </div>
  );
};
